// src/Pages/grantaide-database-site/Filter/SaveFilterButton/index.js
import { useContext } from "react";
import { filterDataContext } from "../FilterDataProvider";
import SlButton from "../../SlButton";

export default function SaveFilter() {
  const {
    setExtendMenu,
    setExtendedName,
  } = useContext(filterDataContext);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {/* Always open the full-panel Save-As screen in Row C */}
      <SlButton
        onClick={() => {
          setExtendedName("Save As");
          setExtendMenu(true);
        }}
        className="py-1 px-3"
        style={{ borderRadius: 8 }}
      >
        Save Filter
      </SlButton>
    </div>
  );
}
